export default __webpack_public_path__ + "static/media/featured3.d3e5a8d5.png";